<script>
// 手机号输入：只允许数字、长度锁 11 位；
// 其余属性/事件（size / class / style / disabled / on-change ...）透传给 iView Input。
//
// 这里用 render 而不是 template：iView 的 Input 靠「带 slot 属性的子节点」接收前缀插槽，
// 而本项目的老版 eslint-plugin-vue(v5) 会把这类子节点误判成多个模板根节点
// （vue/valid-template-root），写在 template 里过不了 lint。
export default {
  name: 'PhoneInput',
  // 未声明的属性统一走 $attrs 透传，避免和 iView Input 的 props 打架
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    // 手机号固定 11 位；确有大号码需求时再显式传
    maxlength: {
      type: [String, Number],
      default: 11
    },
    placeholder: {
      type: String,
      default: '请填写手机号'
    }
  },
  methods: {
    // 键盘输入阶段就挡掉非数字（字母、空格、符号），避免「输了却进不去」的困惑
    handleKeypress(e) {
      // 组合键（复制/粘贴/全选等）和功能键（退格/方向键，key 长度 > 1）放行
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (!e.key || e.key.length > 1) return;
      if (!/\d/.test(e.key)) e.preventDefault();
    },
    // 粘贴 / 输入法 / 拖拽进来的内容在这里清洗：非数字去掉、超出长度截断
    handleInput(val) {
      let digits = String(val === undefined || val === null ? '' : val).replace(
        /\D/g,
        ''
      );
      // 粘贴带国家码的号码时先把 86 / 0086 去掉：国内手机号以 1 开头，
      // 否则截到 11 位会得到 86138000000 这种错号（超长的分机号不受影响）
      if (digits.length > 11) {
        if (digits.indexOf('0086') === 0) {
          digits = digits.slice(4);
        } else if (digits.indexOf('86') === 0) {
          digits = digits.slice(2);
        }
      }
      digits = digits.slice(0, Number(this.maxlength) || 11);
      this.$emit('input', digits === val ? val : digits);
    }
  },
  render(h) {
    // 调用方传了前缀插槽就原样透传；没传就不渲染，
    // 否则 iView 会渲染一段空的 prepend 外壳，把输入框左边撑出空白
    const children = this.$slots.prepend
      ? [h('template', { slot: 'prepend' }, this.$slots.prepend)]
      : [];
    return h(
      'Input',
      {
        attrs: this.$attrs,
        props: {
          value: this.value,
          maxlength: this.maxlength,
          type: 'tel',
          placeholder: this.placeholder
        },
        on: Object.assign({}, this.$listeners, {
          'on-keypress': this.handleKeypress,
          input: this.handleInput
        })
      },
      children
    );
  }
};
</script>
